export default __webpack_public_path__ + "static/out_sourcing3-ad79197b093f45b05652f02a4b38e162.jpg";